import { INotification, UpdateNotificationDto } from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class NotificationApi {
  static getNotifications(): Promise<AxiosResponse<INotification[]>> {
    return AdmiralApi.apiCall<INotification[]>({
      method: 'POST',
      url: `${BASE_URL}/notification`,
    });
  }

  static update(id: string, dto: UpdateNotificationDto): Promise<AxiosResponse<INotification>> {
    return AdmiralApi.apiCall<INotification>({
      method: 'PATCH',
      url: `${BASE_URL}/notification/${id}`,
      data: dto,
    });
  }

  static delete(id: string): Promise<AxiosResponse<void>> {
    return AdmiralApi.apiCall<void>({
      method: 'DELETE',
      url: `${BASE_URL}/notification/${id}`,
    });
  }
}
